import { Body, Controller, Delete, Get, Param, Post, Put } from "@nestjs/common";
import { RolesService } from "./roles.service";
import { RoleEntity } from "./entities";
import { ApiTags } from "@nestjs/swagger";

@ApiTags('roles')
@Controller('roles')
export class RolesController {
    constructor(private rolesService: RolesService) {}

    @Post()
    createRole(@Body() role: Partial<RoleEntity>) {
        return this.rolesService.createRole(role);
    }

    @Put(':id')
    updateRole(@Param('id') id: number, @Body() role: Partial<RoleEntity>) {
        return this.rolesService.updateRole(id, role);
    }

    @Delete(':id')
    deleteRole(@Param('id') id: number) {
        return this.rolesService.deleteRole(id);
    }

    @Get()
    getRoles() {
        return this.rolesService.getRoles();
    }

    @Get(':id')
    getRoleById(@Param('id') id: number) {
        return this.rolesService.getRoleById(id);
    }

    @Post('assign')
    assignRoleToUser(@Body() data: { userId: number, roleId: number }) {
        return this.rolesService.assignRoleToUser(data.userId, data.roleId);
    }
}
